import axios from "axios";

const classPrefix = 'header';
const dataPrefix = 'data-header';

// ищем по data-атрибуту сначала, иначе по классу
const $container = document.querySelector(`[${dataPrefix}]`) || document.querySelector(`.${classPrefix}`);

if ($container) {
    header($container);
}

export function header(root = $container) {

}
